import './EditForm.less';
// import EditControl from '../CmnMisControls/EditControls/EditControl.js';
import { Grid } from './Grid';
import FormLayout from './FormLayout';

export default {
    // components: { EditControl },
    props: {
        value: {
            type: Object
        },
        layout: {
            type: Object,
            default: () => ({})
        },
        isCustomLayoutMode: {
            type: Boolean,
            default: false
        },
        colInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            Value: this.value
        };
    },
    watch: {
        value() {
            this.Value = this.value;
        },
        Value() {
            this.$emit('input', this.Value);
        }
    },
    created() {},
    methods: {
        GetValueList() {},
        SetValueList(value) {},

        async OnLayoutChange(layout) {
            try {
                layout = {
                    ...CmnMis.CurUserForm.LayoutCfg,
                    VueEditLayout: layout
                };
                const _res = await CmnMis.TableOpt.UpdateRec(
                    (await CmnMis.TableOpt.GetUserFormIDByDesc(
                        '用户表单管理'
                    )) || 1,
                    CmnMis.CUF.UserFormID,
                    { layout_config: JSON.stringify(layout) }
                );
                if (_res.IsSuccess === '1') {
                    Cmn.Modal.Success('保存布局成功');
                } else {
                    console.log(_res.ErrMsg);
                }
            } catch (e) {
                console.error(e);
            }
        },

        validate(...args) {
            return this.$refs.DateForm.validate(...args);
        },

        validateField(...args) {
            return this.$refs.DateForm.validateField(...args);
        },

        resetFields(...args) {
            return this.$refs.DateForm.resetFields(...args);
        },

        clearValidate(...args) {
            return this.$refs.DateForm.clearValidate(...args);
        }
    },
    render(h) {
        // let _editInfoList = this.colInfo.filter(
        //     item => item.IsShowInEdit === '1'
        // );

        this.layout?.VueEditLayout?.ControlCfg || [];
        const _controlCfg = this.layout?.VueEditLayout ?? {
            Children: [],
            PositionInfo: { Column: 1, Row: 1, Columns: 24, Rows: 0 }
        };

        let _list = [_controlCfg];

        for (let _i = 0; _i < _list.length; _i++) {
            if (Array.isArray(_list[_i])) {
                _list = _list.concat(_list[_i].Children);
            }
        }

        const _controlInfoList = this.colInfo
            .map(info => {
                const _findColumn = item =>
                    item.ColInfo?.ColName === info.ColName;

                const _column = _list.find(_findColumn);

                if (!_column) {
                    return null;
                }

                return {
                    Info: info,
                    LayoutCfg: _column
                };
            })
            .filter(item => item)
            .sort(function(item1, item2) {
                const _layoutCfg1 = item1.LayoutCfg;
                const _layoutCfg2 = item2.LayoutCfg;

                const _compared =
                    _layoutCfg1.Row +
                    _layoutCfg1.Rows -
                    (_layoutCfg2.Row + _layoutCfg2.Rows);

                if (_compared === 0) {
                    return _layoutCfg1.Column - _layoutCfg2.Column;
                }

                return _compared;
            });

        // const rules = this.colInfo.reduce((rules, colInfo) => {

        //     let _rules = [];

        //     const desc = colInfo?.ColTitle || colInfo?.ControlCfg?.ColTitle || colInfo.ColName || "";

        //     if (colInfo.ControlCfg.IsRequired === '1') {
        //         _rules.push({ required: true, message: `请录入${desc}！`, trigger: 'blur' });
        //     }

        //     if (colInfo?.ControlCfg?.RegexContent) {
        //         let _regex = colInfo.ControlCfg.RegexContent;

        //         if (_regex[0] == "/") { _regex = _regex.substr(1, _regex.length - 2); };

        //         _rules.push({
        //             pattern: new RegExp(_regex),
        //             message: colInfo.ControlCfg.RegexErrorMsg || `${desc}录入的数据不合法！`,
        //             trigger: 'blur'
        //         });
        //     }

        //     rules[colInfo.ColName] = _rules;

        //     return rules;
        // }, {});

        // return (
        //    <div class="cmn-editForm">
        //        <a-form-model
        //            props={{
        //                model: this.Value,
        //                layout: 'inline'
        //                // rules
        //            }}
        //            onSubmit={(...args) => {
        //                this.$emit('submit', ...args);
        //            }}
        //            onValidate={(...args) => {
        //                this.$emit('validate', ...args);
        //            }}
        //            ref="DateForm"
        //            class="cmn-editForm-content"
        //        >
        //            <FormLayout
        //                layoutConfig={_controlCfg}
        //                isCustomLayoutMode={this.isCustomLayoutMode}
        //                colInfoList={this.colInfo}
        //                scopedSlots={{
        //                    cell: cellLayoutConfig => {
        //                        // key={cellLayoutConfig.ID}
        //                        return (
        //                            <EditControl
                                        
        //                                v-model={
        //                                    this.Value[
        //                                        cellLayoutConfig.ColInfo.ColName
        //                                    ]
        //                                }
        //                                colInfo={cellLayoutConfig.ColInfo}
        //                            />
        //                        );
        //                    },
        //                    ...(this.$scopedSlots || {})
        //                }}
        //            ></FormLayout>
        //        </a-form-model>
        //    </div>
        // );
         return (
             <div class="cmn-editForm">
                 <a-form-model
                         props={{
                             model: this.Value,
                             layout: "inline",
                             // rules
                         }}
                         onSubmit={(...args) => {
                             this.$emit("submit", ...args);
                         }}
                         onValidate={(...args) => {
                             this.$emit("validate", ...args);
                         }}
                         ref="DateForm"
                         class="cmn-editForm-content"
                     >
                         <Grid class="cg-edit-control-container"
                             colInfo={this.colInfo}
                             isCustomLayoutMode={this.isCustomLayoutMode}
                             onLayoutChange={this.OnLayoutChange}
                             layoutCfg={this.layout}
                             scopedSlots={{
                                 cell: cellLayoutConfig => {
                                     return (<CgEditControl
                                         key={cellLayoutConfig.ID}
                                         v-model={this.Value[cellLayoutConfig.ColInfo.ColName]}
                                         colInfo={cellLayoutConfig.ColInfo}
                                         layoutCfg={cellLayoutConfig.PositionInfo}
                                     />);
                                 },
                                 ...(this.$scopedSlots || {})
                             }} />
                     </a-form-model>
             </div>
         );
    }
};
